import angular from 'angular';
import KlarnaPaymentService from "../klarna/klarna-payment.service";
import KlarnaExpressService from "../klarna/klarna-express.service";

let klarna = angular
    .module('klarna', [])
    .service('KlarnaPaymentService', KlarnaPaymentService)
    .service('KlarnaExpressService', KlarnaExpressService);

export default klarna;
